var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8 8H31.2C35.6804 8 37.9206 8 39.6319 8.87195C41.1372 9.63894 42.3611 10.8628 43.1281 12.3681C44 14.0794 44 16.3196 44 20.8V27.2C44 31.6804 44 33.9206 43.1281 35.6319C42.3611 37.1372 41.1372 38.3611 39.6319 39.1281C37.9206 40 35.6804 40 31.2 40H16.8C12.3196 40 10.0794 40 8.36808 39.1281C6.86278 38.3611 5.63894 37.1372 4.87195 35.6319C4 33.9206 4 31.6804 4 27.2V20.8C4 16.3196 4 14.0794 4.87195 12.3681C5.63894 10.8628 6.86278 9.63894 8.36808 8.87195C10.0794 8 12.3196 8 16.8 8ZM19 29.9816V18.0183C19 16.3468 20.9497 15.4023 22.2964 16.4215L30.2008 22.4031C31.2664 23.2096 31.2664 24.7904 30.2008 25.5968L22.2964 31.5785C20.9497 32.5976 19 31.6531 19 29.9816Z",
    stroke: "#77D4E1",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadIcon);
export default __webpack_public_path__ + "static/media/file_upload_icon.0b2361a7fd4f67921afe979a7eaf2e97.svg";
export { ForwardRef as ReactComponent };